import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ArrowDownIcon = createIcon({
  displayName: 'ArrowDown',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M12,19v-14"></path>
        <path d="M17.001,13.999l-5.001,5.001l-5.001,-5.001"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const ArrowDown: FC<IconProps> = (props) => {
  return <CustomIcon as={ArrowDownIcon} {...props} />
}

export default memo(ArrowDown)
